const lang = {
  landing: {
    ko: {
      title: "제주 4・3 메타버스",
      subTitle: "어둠의 역사를 빛의 역사로!",
    },
    en: {
      title: "Jeju 4・3 Metaverse",
      subTitle: "Walking the Jeju 4・3 Trails in Metaverse!",
    },
    cn: {
      title: "济州4・3元宇宙",
      subTitle: "走遍元宇宙济州43条小道！",
    },
    jp: {
      title: "済州4・3メタバース",
      subTitle: "メタバースで済州43トレイルを歩く!",
    },
  },
  introEnter: {
    ko: "입장하기",
    en: "Enterance",
    cn: "入口",
    jp: "入場",
  },
  linkModal: {
    ko: {
      title: "연관 사이트",
    },
    en: {
      title: "Related Organization",
    },
    cn: {
      title: "有关机构",
    },
    jp: {
      title: "関連機関",
    },
  },
  mainMenu: {
    ko: {
      menu: "메뉴",
    },
    en: {
      menu: "Menu",
    },
    cn: {
      menu: "菜单",
    },
    jp: {
      menu: "メニュー",
    },
  },
  mainModal: {
    ko: {
      1: {
        title: "백조일손지지/섯알오름/만벵듸",
        vrButtons: [
          {
            name: "백조일손지지",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/baekjoilsonjiji_collective_cemetery/",
          },
          {
            name: "제주예비검속 백조일손 역사관",
            link: "https://premium.360vrmuseum.com/?m=bknkek1qKc5&play=0&qs=0&hr=1&isintrovideo=0&isRightPannel=1&logo=0",
          },
          {
            name: "섯알오름",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/seodal_oreum/",
          },
          {
            name: "만벵듸",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/manbengdui_cemetery/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "모슬포 섯알오름에서 집단학살과, 같은 날 백조일손지지의 다른 구덩이에서 학살사건이 일어났습니다. 백조일손지지와 만벵듸는 희생자의 집단묘지입니다.",
        address:
          "백조일손지지 : 제주 서귀포시 대정읍 상모리 586-1\n제주 예비검속 백조일손 역사관 : 제주 서귀포시 대정읍 송악관광로 143번길 170-48\n섯알오름 : 제주 서귀포시 대정읍 상모리 1618\n만벵듸 : 제주 제주시 한림읍 갯거리오름길 114",
      },
      2: {
        title: "곤을동 잃어버린 마을",
        vrButtons: [
          {
            name: "곤을동 잃어버린 마을",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/lost_village_goneul-dong/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "잃어버린 마을 곤을동은 제주시 중심가와 가까운 별도봉 동편 자락에 위치한 4·3 유적지입니다. 4·3 사건 당시 전소된 가옥중에서 복구되지 못한 마을을 ‘잃어버린 마을’이라 부릅니다.",
        address: "곤을동 잃어버린 마을 : 제주 제주시 화북일동 4429",
      },
      3: {
        title: "주정공장 옛터",
        vrButtons: [
          {
            name: "주정공장 옛터",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/former_distillery_site/",
          },
          {
            name: "주정공장수용소 4・3 역사관",
            link: "https://premium.360vrmuseum.com/?m=ByMaSeN1Rfi&play=0&qs=0&hr=1&logo=0&search=0&isintrovideo=0&isRightPannel=1",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "제주주정공장은 고구마를 주원료로 생산하는 대규모 공장으로, 4·3 사건 당시 수용소로 활용 되었습니다. 지금은 당시의 건물들이 모두 헐려 그 흔적은 찾아볼 수 없습니다.",
        address:
          "주정공장 옛터 : 제주 제주시 만덕로 3길 26\n주정공장수용소 4・3역사관 : 제주 제주시 임항로 98",
      },
      4: {
        title: "북촌 너븐숭이",
        vrButtons: [
          {
            name: "북촌 너븐숭이",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/neobeunsungi/",
          },
          {
            name: "너븐숭이 4・3 기념관",
            link: "https://premium.360vrmuseum.com/?m=zGN2XvCheXv&play=0&qs=0&hr=1&ih=1&iiv=1&logo=1&irp=1&map=1",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "북촌 너븐숭이는 북촌리 조천읍의 4·3 사건의 가장 피해가 큰 학살 장소 입니다. 학살된 북촌리 주민들을 위령하기 위해 너븐숭이 빌레를 조성 하여 위령비, 기념관 등이 건립되어 있습니다.",
        address:
          "북촌 너븐숭이 : 제주 제주시 조천읍 북촌리 1179-2\n너븐숭이 4・3기념관 : 제주 제주시 조천읍 북촌3길 3",
      },
      5: {
        title: "낙선동 4・3성",
        vrButtons: [
          {
            name: "낙선동 4・3성",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/nackseon-dong_43fortress/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "아픈 세월을 이기고 살아남은 주민들이 낙선동에 성을 쌓고 집단 거주 하였습니다. 4·3성은 무장대의 침입을 막는다는 명분으로 마을에 쌓은 성 중에서 원형을 가장 잘 보존하고 있는 유적지입니다.",
        address: "낙선동 4・3성 : 제주 제주시 조천읍 선흘서5길 7",
      },
      6: {
        title: "다랑쉬굴",
        vrButtons: [
          {
            name: "다랑쉬굴",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/darangshi_cave/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          " 다랑쉬굴은 하도리와 종달리 주민들이 피신해 살다가 발각되어 집단 학살된 장소입니다. 지금도 그들이 사용했던 솥, 항아리, 물허벅 등 생활도구가 굴 속에 그대로 남아있습니다.",
        address: "다랑쉬굴 : 제주 제주시 구좌읍 세화리 2608-6",
      },
      7: {
        title: "4・3 메모리얼 파크",
        subTitle: "4・3 Memorial Park",
        vrButtons: [],
        spaceButtons: ["METAVERSE"],
        description:
          " 4·3 메모리얼 파크는 흩어져 있는 4·3 유적지를 한 공간에서 기억해 볼 수 있는 공간입니다. 4·3 유적지의 본 모습과 함께 그 안에 숨겨진 또 다른 의미를 찾아보세요.",
      },
      8: {
        title: "큰넓궤",
        vrButtons: [
          {
            name: "큰넓궤",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/keunneolgwe/index.html?logo=1&lang=1&name_view=0",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "큰넓궤는 제주 4·3 당시 동광리 주민들이 2개월동안 집단적으로 은신 생활을 했던 곳입니다. 이곳은 험한 대신 넓었고, 사람들이 숨어 살기 좋았던 곳입니다.",
        address: "큰넓궤 : 제주 서귀포시 안덕면 동광리 산 90번지 일대",
      },
    },
    en: {
      1: {
        title: "Baekjoilsonjiji/Seodal Oreum/Manbengdui",
        vrButtons: [
          {
            name: "Baekjoilsonjiji",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/baekjoilsonjiji_collective_cemetery/",
          },
          {
            name: "Baekjoilson Memorial Hall",
            link: "https://premium.360vrmuseum.com/?m=bknkek1qKc5&play=0&qs=0&hr=1&isintrovideo=0&isRightPannel=1&logo=0",
          },
          {
            name: "Seodal Oreum",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/seodal_oreum/",
          },
          {
            name: "Manbengdui Cemetery",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/manbengdui_cemetery/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "A number of people who were detained during preventive detention maneuvers and killed at Seodal Oreum are buried here while others are buried in Baekjoilsonjiji. It was not possible to identify the bodies so the families assembled a communal graveyard for all the victims.",
      },
      2: {
        title: "The Lost Village of Goneul-dong",
        vrButtons: [
          {
            name: "The Lost Village of Goneul-dong",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/lost_village_goneul-dong/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Lost Village of Goneul-dong is located at the central Jeju. Among the villages were destroyed during the Jeju 4·3. But the village was never restored.",
      },
      3: {
        title: "Former Distillery Site",
        vrButtons: [
          {
            name: "Former Distillery Site",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/former_distillery_site/",
          },
          {
            name: "4・3 History Museum",
            link: "https://premium.360vrmuseum.com/?m=ByMaSeN1Rfi&play=0&qs=0&hr=1&logo=0&search=0&isintrovideo=0&isRightPannel=1",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Oriental Development Company Jeju Distillery was an important industrial facility before and after liberation. People who were arrested as part of pacification activities were detained in this warehouse during the Jeju 4·3.",
      },
      4: {
        title: "Neobeunsungi",
        vrButtons: [
          {
            name: "Neobeunsungi",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/neobeunsungi/",
          },
          {
            name: "Neobeunsungi 4・3 Memorial Hall",
            link: "https://premium.360vrmuseum.com/?m=zGN2XvCheXv&play=0&qs=0&hr=1&ih=1&iiv=1&logo=1&irp=1&map=1",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The massacre committed at Bukchon village, it stands out for its brutality even among the horrors of the Jeju 4·3. In Neobeunsungi, a memorial hall and a memorial monument were built near the filed.",
      },
      5: {
        title: "Nakseon-dong 4・3 Fortress",
        vrButtons: [
          {
            name: "Nakseon-dong 4・3 Fortress",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/nackseon-dong_43fortress/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Nakseon-dong 4·3 Fortress is relatively well preserved. The Fortress-like enclosure was purportedly built to block and prevent attacks from the armed resistance.",
      },
      6: {
        title: "Darangshi Cave",
        vrButtons: [
          {
            name: "Darangshi Cave",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/darangshi_cave/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "Eleven villagers of Hado-ri and Jongdal-ri hid from the massacre in Darangshi cave until they were discovered by state forces. Darangshi cave as it was discovered in 1992 with some of the items used by the victims while they hid in the cave.",
      },
      7: {
        title: "4・3 Memorial Park",
        vrButtons: [],
        spaceButtons: ["METAVERSE"],
        description:
          "The 4·3 Memorial Park contained to provide a valuable opportunity to visit the metaverse space. Find about how the significance of sculptures impacted in each space by the historical telling.",
      },
      8: {
        title: "Keunneolgwe (Big Wide Cave)",
        vrButtons: [
          {
            name: "Keunneolgwe",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/keunneolgwe/index.html?logo=1&lang=1&name_view=0",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "Keunneolgwe Cave served as a hideout for villagers from Donggwang-ri village for about two months during the Jeju April 3rd Massacre. It rugged yet wide space was ideal for villagers to live in hiding.",
        address: "Keunneolgwe : Around San 90, Donggwang-ri, Andeok-myeon, Seogwipo-si, Jeju",
      },
    },
    cn: {
      1: {
        title: "百祖一孙墓/西卵岳/Manbengdui村庄",
        vrButtons: [
          {
            name: "百祖一孙墓",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/baekjoilsonjiji_collective_cemetery/",
          },
          {
            name: "百祖一孙 纪念馆",
            link: "https://premium.360vrmuseum.com/?m=bknkek1qKc5&play=0&qs=0&hr=1&isintrovideo=0&isRightPannel=1&logo=0",
          },
          {
            name: "西卵岳",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/seodal_oreum/",
          },
          {
            name: "Manbengdui",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/manbengdui_cemetery/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "A number of people who were detained during preventive detention maneuvers and killed at Seodal Oreum are buried here while others are buried in Baekjoilsonjiji. It was not possible to identify the bodies so the families assembled a communal graveyard for all the victims.",
      },
      2: {
        title: "坤乙洞",
        vrButtons: [
          {
            name: "坤乙洞",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/lost_village_goneul-dong/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Lost Village of Goneul-dong is located at the central Jeju. Among the villages were destroyed during the Jeju 4·3. But the village was never restored.",
      },
      3: {
        title: "Former Distillery Site",
        vrButtons: [
          {
            name: "Former Distillery Site",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/former_distillery_site/",
          },
          {
            name: "4・3 History Museum",
            link: "https://premium.360vrmuseum.com/?m=ByMaSeN1Rfi&play=0&qs=0&hr=1&logo=0&search=0&isintrovideo=0&isRightPannel=1",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Oriental Development Company Jeju Distillery was an important industrial facility before and after liberation. People who were arrested as part of pacification activities were detained in this warehouse during the Jeju 4·3.",
      },
      4: {
        title: "北村宽石",
        vrButtons: [
          {
            name: "北村宽石",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/neobeunsungi/",
          },
          {
            name: "宽石4.3纪念馆",
            link: "https://premium.360vrmuseum.com/?m=zGN2XvCheXv&play=0&qs=0&hr=1&ih=1&iiv=1&logo=1&irp=1&map=1",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The massacre committed at Bukchon village, it stands out for its brutality even among the horrors of the Jeju 4·3. In Neobeunsungi, a memorial hall and a memorial monument were built near the filed.",
      },
      5: {
        title: "Nakseon-dong 4・3 Fortress",
        vrButtons: [
          {
            name: "Nakseon-dong 4・3 Fortress",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/nackseon-dong_43fortress/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Nakseon-dong 4·3 Fortress is relatively well preserved. The Fortress-like enclosure was purportedly built to block and prevent attacks from the armed resistance.",
      },
      6: {
        title: "月郎峰洞穴",
        vrButtons: [
          {
            name: "月郎峰洞穴",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/darangshi_cave/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "Eleven villagers of Hado-ri and Jongdal-ri hid from the massacre in Darangshi cave until they were discovered by state forces. Darangshi cave as it was discovered in 1992 with some of the items used by the victims while they hid in the cave.",
      },
      7: {
        title: "4・3 纪念公园",
        vrButtons: [],
        spaceButtons: ["METAVERSE"],
        description:
          "The 4·3 Memorial Park contained to provide a valuable opportunity to visit the metaverse space. Find about how the significance of sculptures impacted in each space by the historical telling.",
      },
      8: {
        title: "Keunneolgwe (Big Wide Cave)",
        vrButtons: [
          {
            name: "Keunneolgwe",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/keunneolgwe/index.html?logo=1&lang=1&name_view=0",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "Keunneolgwe Cave served as a hideout for villagers from Donggwang-ri village for about two months during the Jeju April 3rd Massacre. It rugged yet wide space was ideal for villagers to live in hiding.",
        address: "Keunneolgwe : Around San 90, Donggwang-ri, Andeok-myeon, Seogwipo-si, Jeju",
      },
    },
    jp: {
      1: {
        title: "伯祖一孫墓域/ソダルオルム/マンベンジ村",
        vrButtons: [
          {
            name: "伯祖一孫墓域",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/baekjoilsonjiji_collective_cemetery/",
          },
          {
            name: "百祖一孙 記念館",
            link: "https://premium.360vrmuseum.com/?m=bknkek1qKc5&play=0&qs=0&hr=1&isintrovideo=0&isRightPannel=1&logo=0",
          },
          {
            name: "ソダルオルム",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/seodal_oreum/",
          },
          {
            name: "マンベンジ",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/manbengdui_cemetery/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "A number of people who were detained during preventive detention maneuvers and killed at Seodal Oreum are buried here while others are buried in Baekjoilsonjiji. It was not possible to identify the bodies so the families assembled a communal graveyard for all the victims.",
      },
      2: {
        title: "コンウルドン",
        vrButtons: [
          {
            name: "コンウルドン",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/lost_village_goneul-dong/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Lost Village of Goneul-dong is located at the central Jeju. Among the villages were destroyed during the Jeju 4·3. But the village was never restored.",
      },
      3: {
        title: "Former Distillery Site",
        vrButtons: [
          {
            name: "Former Distillery Site",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/former_distillery_site/",
          },
          {
            name: "4・3 History Museum",
            link: "https://premium.360vrmuseum.com/?m=ByMaSeN1Rfi&play=0&qs=0&hr=1&logo=0&search=0&isintrovideo=0&isRightPannel=1",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Oriental Development Company Jeju Distillery was an important industrial facility before and after liberation. People who were arrested as part of pacification activities were detained in this warehouse during the Jeju 4·3.",
      },
      4: {
        title: "北村ノブンスンイ",
        vrButtons: [
          {
            name: "北村ノブンスンイ",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/neobeunsungi/",
          },
          {
            name: "ノブンスンイ4.3記念館",
            link: "https://premium.360vrmuseum.com/?m=zGN2XvCheXv&play=0&qs=0&hr=1&ih=1&iiv=1&logo=1&irp=1&map=1",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The massacre committed at Bukchon village, it stands out for its brutality even among the horrors of the Jeju 4·3. In Neobeunsungi, a memorial hall and a memorial monument were built near the filed.",
      },
      5: {
        title: "Nakseon-dong 4・3 Fortress",
        vrButtons: [
          {
            name: "Nakseon-dong 4・3 Fortress",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/nackseon-dong_43fortress/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "The Nakseon-dong 4·3 Fortress is relatively well preserved. The Fortress-like enclosure was purportedly built to block and prevent attacks from the armed resistance.",
      },
      6: {
        title: "タランシ 洞窟",
        vrButtons: [
          {
            name: "タランシ 洞窟",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/darangshi_cave/",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "Eleven villagers of Hado-ri and Jongdal-ri hid from the massacre in Darangshi cave until they were discovered by state forces. Darangshi cave as it was discovered in 1992 with some of the items used by the victims while they hid in the cave.",
      },
      7: {
        title: "4・3 記念公園",
        vrButtons: [],
        spaceButtons: ["METAVERSE"],
        description:
          "The 4·3 Memorial Park contained to provide a valuable opportunity to visit the metaverse space. Find about how the significance of sculptures impacted in each space by the historical telling.",
      },
      8: {
        title: "Keunneolgwe (Big Wide Cave)",
        vrButtons: [
          {
            name: "Keunneolgwe",
            link: "https://jeju.go.kr/is/onlinejeju43-vr/keunneolgwe/index.html?logo=1&lang=1&name_view=0",
          },
        ],
        spaceButtons: ["METAVERSE"],
        description:
          "Keunneolgwe Cave served as a hideout for villagers from Donggwang-ri village for about two months during the Jeju April 3rd Massacre. It rugged yet wide space was ideal for villagers to live in hiding.",
        address: "Keunneolgwe : Around San 90, Donggwang-ri, Andeok-myeon, Seogwipo-si, Jeju",
      },
    },
  },
};

export default lang;
